import React, { useState } from 'react'
import {
  Grid,
  Typography,
  Button,
  IconButton,
  useTheme
} from '@material-ui/core'
import { Paperclip, Trash2 } from 'lucide-react'
import InputMessage from '../InputMessage'
import { useStyles } from './styles'
import { getBackendURL } from '../../services/config'

const QueueMessagingTab = ({
  values,
  setFieldValue,
  queue,
  queueAttachment,
  onAttachClick,
  onImagePreview,
  onDeleteMedia
}) => {
  const classes = useStyles()
  const theme = useTheme()

  const [, setIsGreetingVariablesOpen] = useState(false)
  const [, setIsOutOfHoursOpen] = useState(false)
  const [, setIsTransferOpen] = useState(false)
  const [, setIsCompletionOpen] = useState(false)
  const [, setIsRatingOpen] = useState(false)

  const getMediaUrl = () => {
    if (queueAttachment) {
      return URL.createObjectURL(queueAttachment)
    }
    if (queue?.mediaPath) {
      if (queue.mediaPath.startsWith('http')) return queue.mediaPath
      return `${getBackendURL()}/public/${queue.mediaPath}`
    }
    return null
  }

  return (
    <Grid container spacing={1} className={classes.contentTab}>
      {/* Linha 1: Saudação e Transferência */}
      <Grid item xs={12} md={6}>
        <InputMessage
          id="greetingMessage"
          label={'Mensagem de Saudação'}
          name="greetingMessage"
          value={values.greetingMessage}
          onChange={e => setFieldValue('greetingMessage', e.target.value)}
          placeholder={
            'Olá! 👋 Bem-vindo ao [Nome da Empresa]. Como posso ajudar você hoje?'
          }
          onToggleVariables={setIsGreetingVariablesOpen}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <InputMessage
          label={'Mensagem de Transferência'}
          name="transferMessage"
          value={values.transferMessage}
          onChange={e => setFieldValue('transferMessage', e.target.value)}
          placeholder={
            'Aguarde um momento que seu atendimento foi transferido.'
          }
          onToggleVariables={setIsTransferOpen}
        />
      </Grid>

      {/* Linha 2: Fora de Hora e Conclusão */}
      <Grid item xs={12} md={6}>
        <InputMessage
          label={'Mensagem Fora do Expediente'}
          name="outOfHoursMessage"
          value={values.outOfHoursMessage}
          onChange={e => setFieldValue('outOfHoursMessage', e.target.value)}
          placeholder={
            'Olá! No momento, estamos fora do horário de atendimento.'
          }
          onToggleVariables={setIsOutOfHoursOpen}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <InputMessage
          label={'Mensagem de Conclusão'}
          name="complationMessage"
          value={values.complationMessage}
          onChange={e => setFieldValue('complationMessage', e.target.value)}
          placeholder={
            'Foi um prazer ajudar você! 😊 Se precisar de mais alguma coisa, estamos à disposição.'
          }
          onToggleVariables={setIsCompletionOpen}
        />
      </Grid>

      {/* Linha 3: Avaliação e Anexo */}
      <Grid item xs={12} md={6}>
        <InputMessage
          label={'Mensagem de Avaliação'}
          name="ratingMessage"
          value={values.ratingMessage}
          onChange={e => setFieldValue('ratingMessage', e.target.value)}
          placeholder={
            'Você poderia nos ajudar avaliando o atendimento? Sua opinião é muito importante para melhorarmos.'
          }
          onToggleVariables={setIsRatingOpen}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <div className={classes.activeBox}>
          <div className={classes.attachmentContainer}>
            <div className={classes.attachmentInfo}>
              <Typography
                variant="caption"
                color="textSecondary"
                align="center"
                style={{ display: 'block', width: '100%' }}
              >
                Formatos: JPG, JPEG, PNG, BMP
              </Typography>

              <div className={classes.attachmentContent}>
                <Button
                  fullWidth
                  className={classes.buttonsAttachmentFile}
                  onClick={
                    queue?.mediaPath || queueAttachment
                      ? onImagePreview
                      : onAttachClick
                  }
                >
                  {queue?.mediaPath || queueAttachment ? (
                    <img
                      src={getMediaUrl()}
                      alt="Preview"
                      className={classes.attachmentPreviewImage}
                    />
                  ) : (
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      className={classes.attachmentNotFile}
                    >
                      <Paperclip size={24} style={{ marginRight: 8 }} /> Anexar
                      Imagem
                    </Typography>
                  )}
                </Button>

                {(queueAttachment || queue?.mediaPath) && (
                  <IconButton
                    size="small"
                    onClick={e => {
                      e.stopPropagation()
                      onDeleteMedia()
                    }}
                    className={classes.iconButtonDelete}
                    style={{
                      position: 'absolute',
                      top: '10px',
                      right: '10px',
                      backgroundColor: theme.palette.white_100.main,
                      padding: '4px',
                      zIndex: 10
                    }}
                  >
                    <Trash2 size={16} />
                  </IconButton>
                )}
              </div>
            </div>
          </div>
        </div>
      </Grid>
    </Grid>
  )
}

export default QueueMessagingTab
